function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#78909C",
  d: "M6 28v10a4 4 0 004 4h28a4 4 0 004-4V28H6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#455A64",
  d: "M42 28a4 4 0 01-4 4H10a4 4 0 01-4-4l3-18c.219-2.094 1.791-4 4-4h22c2.209 0 3.688 1.75 4 4l3 18z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#64DD17",
  d: "M35 35a2 2 0 100 4 2 2 0 100-4z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#BBDEFB",
  d: "M24 11c-6.627 0-12 3.134-12 7 0 3.865 5.373 7 12 7s12-3.135 12-7c0-3.866-5.373-7-12-7zm0 8.555c-1.473 0-2.667-.695-2.667-1.555s1.194-1.556 2.667-1.556 2.666.696 2.666 1.556-1.193 1.555-2.666 1.555z"
});

var Svg13EdgarHd = function Svg13EdgarHd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg13EdgarHd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/13-edgar-hd.7c5af295.svg";
export { ForwardRef as ReactComponent };